export const calendarModals = {
  common: {
    cancel: "Annuler",
  },
  arrival: {
    title: "Règles du calendrier",
    loading: "Chargement des paramètres…",
    daysTitle: "Jours d'arrivée et de départ",
    canArrive: "Les voyageurs peuvent arriver",
    canDepart: "Les voyageurs peuvent partir",
    daysHint:
      "Avec <b>tout sélectionné</b>, il n'y a aucune restriction. Si vous n'autorisez les arrivées que le lundi et les départs que le dimanche, chaque réservation durera exactement une semaine.",
    summaryAny: "Les voyageurs peuvent arriver et partir n'importe quel jour",
    summaryArrival: "arrivée {n} jours sur 7",
    summaryDeparture: "départ {n} jours sur 7",
    summaryRestricted: "Restreint : {detail}",
    cutoffTitle: "Fermer les ventes du jour après une heure définie",
    cutoffToggle: "Fermer automatiquement les ventes du jour même",
    cutoffToggleHint: "Tant que ceci est désactivé, vous acceptez les check-ins pour aujourd'hui à toute heure.",
    cutoffFrom: "À partir de",
    cutoffTz: "l'heure de votre propriété",
    cutoffTzNow: "là-bas il est {time}",
    cutoffHintPre: "Chaque jour, à ",
    cutoffHintMid: " à ",
    cutoffHintPost:
      ", vous cesserez de recevoir des réservations pour ce même jour. Les jours suivants restent ouverts comme d'habitude.",
    cutoffSummaryOn: "Les ventes ferment chaque jour à {time}",
    cutoffSummaryOff: "Vous acceptez les check-ins pour aujourd'hui à toute heure",
    turnoverTitle: "Temps de préparation",
    turnoverQuestion: "De combien de nuits avez-vous besoin entre un voyageur et le suivant ?",
    turnoverOptNone: "Aucune",
    nights: "{count} nuit | {count} nuits",
    custom: "Personnalisé",
    customLabel: "Nuits",
    customAside: "de chaque côté, jusqu'à 7",
    turnoverSummaryNone: "Les voyageurs peuvent arriver le jour même où un autre part",
    turnoverSummarySet: "Gardez {nights} entre un voyageur et le suivant",
    turnoverLegacySummaryAfter: "Ne s'applique qu'après le départ · enregistrez pour couvrir les deux côtés",
    turnoverLegacySummaryBefore: "Ne s'applique qu'avant l'arrivée · enregistrez pour couvrir les deux côtés",
    turnoverLegacyNoteAfter: "Cette règle vient de la version précédente et ne bloque aujourd'hui qu'après le départ, pas avant l'arrivée. En enregistrant, elle s'appliquera des deux côtés, et nous vous indiquerons d'abord combien de nuits seront fermées.",
    turnoverLegacyNoteBefore: "Cette règle vient de la version précédente et ne bloque aujourd'hui qu'avant l'arrivée, pas après le départ. En enregistrant, elle s'appliquera des deux côtés, et nous vous indiquerons d'abord combien de nuits seront fermées.",
    exampleLabel: "Exemple",
    exampleCaption: "Une réservation arrivant le 15 et partant le 18",
    legendStay: "Séjour",
    legendPrep: "Préparation",
    legendFree: "En vente",
    turnoverMoveHint:
      "Le blocage se déplace tout seul si les dates changent et disparaît si la réservation est annulée.",
    impactClosePre: "Ceci fermera ",
    impactClosePost: " dans vos canaux.",
    impactOpenPre: "Ceci ouvrira ",
    impactOpenPost: ".",
    impactRetry: "Appuyez à nouveau sur « Enregistrer les règles » pour l'appliquer.",
    fallbackHost: "votre propriété",
    saving: "Enregistrement…",
    applyYes: "Oui, appliquer",
    saveRules: "Enregistrer les règles",
    loadError: "Les paramètres n'ont pas pu être chargés.",
    saveSuccess: "Règles du calendrier enregistrées et envoyées à vos canaux.",
    saveError: "Impossible d'enregistrer.",
    saveConfigError: "Les paramètres n'ont pas pu être enregistrés.",
    linkedTitle: "Vente de l'appartement entier",
    linkedSummaryOff: "Cette unité se vend seule",
    linkedSummaryOn: "Vend le logement entier · inclut {count} chambre | Vend le logement entier · inclut {count} chambres",
    linkedSummaryChild: "Fait partie de {parent}",
    linkedRooms: "{count} ch. | {count} ch.",
    linkedToggle: "Définir comme appartement entier de l'annonce",
    linkedToggleHint: "Pour l'unité qui loue le logement entier. Choisissez ensuite les chambres qu'elle inclut.",
    linkedQuestion: "Quelles chambres inclut-elle ?",
    linkedAll: "Tout cocher",
    linkedNone: "Tout décocher",
    linkedIsParent: "Déjà vendue comme appartement entier",
    linkedGuests: "{count} voyageur | {count} voyageurs",
    linkedExampleCaption: "« {room} » est réservée du 19 au 21",
    linkedExampleRoom: "Chambre 1",
    linkedLegendClosed: "Se ferme tout seul",
    linkedHint: "Et inversement : si l'appartement entier est réservé, toutes ses chambres se ferment. Si la réservation est annulée ou change de dates, tout se rouvre tout seul, sur vos canaux aussi. Tant que la réservation tient, ces fermetures ne peuvent pas être ouvertes à la main.",
    linkedChildPre: "Cette chambre fait partie de ",
    linkedChildPost: ". Si elle est réservée, cet appartement entier se ferme ces nuits-là ; et si l'appartement entier est réservé, cette chambre se ferme toute seule. Cela se modifie dans les règles du calendrier de l'appartement entier.",
    linkedConflicts: "Il y a déjà {count} double vente entre l'appartement entier et ses chambres. Vérifiez-la : | Il y a déjà {count} doubles ventes entre l'appartement entier et ses chambres. Vérifiez-les :",
    linkedNeedsRooms: "Cochez au moins une chambre incluse dans l'appartement entier.",
    linkedSaveError: "Impossible d'enregistrer la vente de l'appartement entier.",
    linkedAlertTitle: "« {unit} » devient l'appartement entier",
    linkedAlertBody: "S'il est réservé, les chambres que vous cochez se fermeront automatiquement, ici et sur vos canaux (Booking, Airbnb…). Et si l'une d'elles est réservée, cette unité se fermera ces nuits-là. Si la réservation est annulée, tout se rouvre tout seul.",
    linkedPartialSave: "La vente de l'appartement entier a été enregistrée, mais pas les autres règles. Réessayez.",
  },
  weekend: {
    title: "Paramètres de prix",
    subtitle: "Ces informations s'afficheront chaque nuit, sauf si vous les personnalisez par date.",
    loading: "Chargement des paramètres…",
    plTitle: "Prix gérés par PriceLabs",
    plDesc1:
      "Cette propriété a la gestion dynamique des prix activée avec PriceLabs. Les prix se mettent à jour automatiquement en fonction de la demande, de la saison et du taux d'occupation.",
    plDesc2: "Pour modifier les prix du week-end, faites-le directement depuis votre panneau PriceLabs.",
    plOpen: "Ouvrir PriceLabs",
    basePriceTitle: "Prix de base",
    basePriceLabel: "Par nuit — appliqué chaque jour",
    customization: "Personnalisation",
    weekendPriceTitle: "Prix du week-end",
    toggleOff: "Désactiver le prix du week-end",
    toggleOn: "Activer le prix du week-end",
    appliesTo: "S'applique le :",
    weekendLabel: "Week-end",
    infoHint: "Il s'appliquera aux <strong>500 prochains jours</strong> pour les jours sélectionnés.",
    disabledText: "Les jours de week-end utiliseront le prix de base de",
    confirmTitle: "Désactiver le prix du week-end ?",
    confirmDescPre: "Les jours reviendront au prix de base de",
    confirmDescPost: "automatiquement.",
    disabling: "Désactivation…",
    confirmDisable: "Oui, désactiver",
    saving: "Enregistrement…",
    saveChanges: "Enregistrer les modifications",
    diffEqual: "identique à la base",
    diffUp: "+{pct}% vs base",
    diffDown: "{pct}% vs base",
    loadError: "Erreur lors du chargement des paramètres de prix",
    disableSuccess: "Prix du week-end désactivé. Les jours reviennent au prix de base.",
    disableError: "Erreur lors de la désactivation du prix du week-end",
    saveSuccess: "Prix enregistrés avec succès",
    saveError: "Erreur lors de l'enregistrement",
  },
};
